import React, { Component } from 'react';
import './ProjectCard.css';
import { getTimeLeft } from '../../Util';

import Clock from '../Icons/Clock.svg';
import User from '../Icons/User.svg';
import BackonLogoWhite from '../Icons/BackonLogoWhite.svg';

const colorsTab = ['#86CFFF','#BFE5FF','#F8CECF','#FAE7E8','#7FADBC','#C9DFE7','#E9E5B7','#F1C28F','#E0E7CB','#D4DDA6','#C2DDA6','#BBE2C8','#BAEAEB'];

class ProjectCard extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	backgroundColor: colorsTab[this.getRandomInt(13)]
	    };
	}

	getRandomInt(max) {
	  return Math.floor(Math.random() * Math.floor(max));
	}

	render() {
		const pictureStyle = {
			backgroundColor: this.state.backgroundColor
		};
		const getProgress = () => {
			let progressValue = 100 * this.props.data.current_amount / this.props.data.target;
			return ((progressValue > 100 ? 100 : progressValue) + '%');
		}

		return (
			<div>
				<div className="picture" style={pictureStyle}>
					{this.props.data.illustration ? <img src={this.props.data.illustration} alt={this.props.data.title} />
					: <div className="fallbackIllu"><img src={BackonLogoWhite} alt={this.props.data.title} /></div>}
				</div>
				<div className="content">
					<div className="title">{this.props.data.title}</div>
					<div className="author">{this.props.data.creator_name}</div>
					<div className="infos">
						<div className="indicators">
							<div className="backers">
								<div className="icon">
									<img src={User} alt="Backers" title="Backers" />
								</div>
								{this.props.data.current_backers === null ? '0' : this.props.data.current_backers}
							</div>
							{!this.props.achieved_at &&
								<div className={"timeLeft " + ((getTimeLeft(this.props.data.project_end_at) > 0) ? "late" : "")}>
									<div className="icon">
										<img src={Clock} alt="Time left" title="Time left" />
									</div>
									<div className="time">
										J{getTimeLeft(this.props.data.project_end_at)}
									</div>
								</div>
							}
						</div>
						<div className={"amount " + (this.props.achieved_at && "achieved")}>
							<div className="currentAmount">€{this.props.data.current_amount === null ? '0' : this.props.data.current_amount}</div>
							/
							<div className="target">€{this.props.data.target}</div>
						</div>
					</div>
				</div>
				<div className={"progression " + (this.props.achieved_at && "achieved")}>
					<div className="progress" style={{'width':getProgress()}}></div>
				</div>
			</div>
		);
	}
}

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/Explore/ProjectCard.js